import React from 'react'
import {Message, Button, Icon, Dimmer, Loader, Header} from 'semantic-ui-react'

import {getLanguageScope} from "../../../../helpers";

const _i18n = getLanguageScope('camera');

import Webcam from "react-webcam";

const styles = {
  webcamContainer: {
    position: 'relative'
  },
  webcam: {
    margin: '0 auto',
    display: 'block',
    position: 'relative',
    borderRadius: 30
  },
  dimmer: {
    borderRadius: 30
  },
  captureButton: {
    position: 'absolute',
    bottom: '20px',
    margin: 'auto',
    left: '50%',
    WebkitTransform: 'translateX(-50%)',
    transform: "translateX(-50%)",
    fontSize: "30px"
  },
  closeButton: {
    position: 'absolute',
    right: '-20px',
    top: '-20px',
    fontSize: '20px'
  }
};

class Camera extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      error: false
    };
  }

  setRef = webcam => {
    this.webcam = webcam;
  };

  capture = () => {
    const {onPhotoCapture} = this.props;

    const imageSrc = this.webcam.getScreenshot();

    onPhotoCapture && onPhotoCapture(imageSrc);
  };

  onUserMedia = () => {
    setTimeout(() => this.setState(() => ({ready: true, error: false})), 1000);
  };

  onUserMediaError = () => {
    this.setState(() => ({error: true}))
  };

  render() {
    const {onCloseCamera} = this.props;
    const {ready, error} = this.state;

    const videoConstraints = {
      width: 700,
      height: 700,
      facingMode: "user"
    };

    return (
      <div style={styles.webcamContainer}>

        <Webcam
          audio={false}
          width={700}
          height={700}
          style={styles.webcam}
          ref={this.setRef}
          onUserMedia={this.onUserMedia}
          onUserMediaError={this.onUserMediaError}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
        />

        <Dimmer style={styles.dimmer} active={!ready}>
          {error ?
            <Loader inverted content={_i18n('user_media_error')}/> :
            <Loader inverted content={_i18n('loading')}/>
          }
        </Dimmer>

        {ready &&
          <Button style={styles.captureButton} onClick={this.capture} color='red' size={'large'} circular icon='camera'/>
        }

        <Icon style={styles.closeButton} onClick={onCloseCamera} link name='close'/>

      </div>
    );
  }
}

export default Camera;


// WEBPACK FOOTER //
// ./src/components/Devices/Camera/components/Camera.js